$(function () {
	'use strict';

	crh.firstVisitBanner.init();

	bravo.utilities.keepDropdownOpen();
	bravo.utilities.carouselTouch();
	bravo.present.init();

	crh.header.init();
	crh.prompt.init();
	crh.globalMessaging.init();
	crh.search.init();
	crh.memberEvents.init();
	crh.swiper.init();
	crh.venue.init();
	crh.accessibility.init();

	if ($(window).width() > 1023) {
		$('.event-info-accordion .collapsed').click();
	}

	if ($('body').hasClass('page-event')) {
		crh.eventDetail.init();
	}

	if ($('body').hasClass('page-whatson')) {
		crh.filters.init();
		crh.accessibility.filters();
	}

	if ($('.favourites-panel').length > 0) {
		$('.favourites-panel .h3').each(function () {
			var $this = $(this);
			if ($this.text().split('').length > 55) {
				$this.addClass('long-title');
			}
		});
	}

	$('[data-toggle="tooltip"]').tooltip({
		//trigger: 'click'
	});

	$('.form-validate').each(function () {
		var $form = $(this);

		//console.log('#' + $form.attr('id'));
		crh.formValidation.validate($('#' + $form.attr('id')), $('#' + $form.next().attr('id')));
	});
});